import * as AT from "./actionTypes";

export const pageLoaded = (path: string) => ({
    type: AT.APP_PAGE_LOADED,
    payload: {
        path,
    },
});

export const setIsGATransactionTracked = (isTracked: boolean) => ({
    type: AT.APP_SET_IS_GA_TRANSACTION_TRACKED,
    isTracked,
});
